import React, { useId } from "react";
import { CHART_COLORS } from "@/features/investors/components/charts/palette";

type Props = {
    values: number[];
    color?: string;
    width?: number;
    height?: number;
};

export const Sparkline: React.FC<Props> = ({
    values,
    color = CHART_COLORS.blue,
    width = 116,
    height = 36,
}) => {
    const gradientId = useId();
    if (values.length < 2) return null;

    const min = Math.min(...values);
    const max = Math.max(...values);
    const range = max - min || 1;
    const points = values.map((value, index): [number, number] => [
        (index / (values.length - 1)) * width,
        height - 4 - ((value - min) / range) * (height - 8),
    ]);
    const line = points
        .map((point, index) => `${index === 0 ? "M" : "L"}${point[0].toFixed(1)} ${point[1].toFixed(1)}`)
        .join(" ");
    const area =
        `M0 ${height} ` +
        points.map((point) => `L${point[0].toFixed(1)} ${point[1].toFixed(1)}`).join(" ") +
        ` L${width} ${height} Z`;
    const last = points[points.length - 1];

    return (
        <svg
            viewBox={`0 0 ${width} ${height}`}
            width={width}
            height={height}
            preserveAspectRatio="none"
            style={{ display: "block" }}
        >
            <defs>
                <linearGradient id={gradientId} x1="0" y1="0" x2="0" y2="1">
                    <stop offset="0" stopColor={color} stopOpacity="0.28" />
                    <stop offset="1" stopColor={color} stopOpacity="0" />
                </linearGradient>
            </defs>
            <path d={area} fill={`url(#${gradientId})`} />
            <path
                d={line}
                fill="none"
                stroke={color}
                strokeWidth={2}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <circle cx={last[0].toFixed(1)} cy={last[1].toFixed(1)} r={2.6} fill={color} />
        </svg>
    );
};
